<template>
            <NuxtLink :to="$localePath({ name: 'index' })" class="font-bold text-2xl text-gray-900 dark:text-white">
  Trivian Demo
</NuxtLink>
</template> 